export default "__VITE_ASSET__BsqI1F$R__"